import requestor from "requestor";

import BaseRoute from "utils/base_route";
import getRouteIds from "utils/get_route_ids";

import TopicDetailContainer from "./containers/topic_detail";

import topicInfoFetchAction from "modules/documents/actions/topic_info_fetch";
import topicClassifiersFetchAction from "modules/documents/actions/topic_classifiers_fetch";
import topicsFetchAction from "modules/documents/actions/topics_fetch";
import rolesFetchAction from "modules/documents/actions/role/roles_fetch";

import topicClearAction from "modules/documents/actions/topic_clear";
import topicsClearAction from "modules/documents/actions/topics_clear";
import issuesClearAction from "modules/documents/actions/issues_clear";
import rolesClearAction from "modules/documents/actions/role/roles_clear";
import templateModulesFetchAction from "../../modules/template_modules/actions/modules_fetch";

export default class TopicDetail extends BaseRoute {
  constructor(store) {
    super(":topicId/detail", store);
  }

  getChildRoutes(state, cb) {
    cb(null, []);
  }

  getComponents(location, cb) {
    cb(null, TopicDetailContainer);
  }

  fetchActiveData(state) {
    this.fetchTopic(state);
    this.fetchTopics(state);
    this.fetchRoles(state);
    this.fetchClassifiers(state);
    this.fetchModules(state);
  }

  fetchTopic(state) {
    const {organisationId, topicId} = getRouteIds(state.router);
    this.store.dispatch(
      topicInfoFetchAction(requestor)(organisationId, topicId),
    );
  }

  fetchTopics(state) {
    const {organisationId} = getRouteIds(state.router);
    this.store.dispatch(topicsFetchAction(requestor)(organisationId));
  }

  fetchClassifiers(state) {
    const {organisationId, topicId} = getRouteIds(state.router);
    this.store.dispatch(
      topicClassifiersFetchAction(requestor)(organisationId, topicId),
    );
  }

  fetchRoles(state) {
    const {organisationId} = getRouteIds(state.router);
    this.store.dispatch(rolesFetchAction(requestor)(organisationId));
  }

  fetchModules(props) {
    const {organisationId} = getRouteIds(props.router);
    if (organisationId) {
      this.store.dispatch(
        templateModulesFetchAction(requestor)(organisationId),
      );
    }
  }

  clearActiveData(state) {
    this.clearTopic(state);
    this.clearIssues(state);
    this.clearRoles(state);
  }

  clearTopic(state) {
    const {organisationId, topicId} = getRouteIds(state.router);
    this.store.dispatch(topicClearAction(organisationId, topicId));
    this.store.dispatch(topicsClearAction(organisationId));
  }

  clearIssues(state) {
    const {organisationId} = state.params;
    this.store.dispatch(issuesClearAction(organisationId));
  }

  clearRoles() {
    this.store.dispatch(rolesClearAction());
  }
}
